/**
 * Mise en forme des montants.
 *
 * Les totaux sont accumules par `reduce` sur des flottants : 129.99 + 261.66
 * rend 391.65000000000003, et l'affichage brut le montrait tel quel. Arrondir
 * au cent et fixer deux decimales est la seule facon d'afficher de l'argent.
 *
 * Locale `en-CA` : separateur de milliers par virgule et decimale par point,
 * pour rester coherent avec le symbole `$` place AVANT le nombre, convention
 * deja en place dans les ecrans de devis.
 *
 * @param {number} montant
 * @returns {string} ex. « 391.65 », « 1,234.50 »
 */
export const formatMontant = (montant) => {
  const valeur = Number(montant);
  if (!Number.isFinite(valeur)) return '0.00';
  return valeur.toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export default formatMontant;
